const serverImg = "https://d39vj9j1h6phln.cloudfront.net/"

// para cuando corres local el intelliJ
// const serverApi = "http://localhost:8080/myfrac_api_war/";
// const serverWeb = "http://localhost:8080/myfrac-web/";

// para rama develop en desarrollo
// const serverApi = "https://prueba.myfrac.com/";
// const serverWeb = "http://administrador-dev.myfrac.com/";

// const serverApi = "https://qa.myfrac.com/";
// const serverWeb = "https://adminqa.myfrac.com/"

// para rama master en produción
const serverApi = "https://api.myfrac.com/";
const serverWeb = "https://administrador.myfrac.com/";

export default {
    serverApi: serverApi,
    serverWeb: serverWeb,
    serverImg: serverImg,
    fireBaseConfig: {
        apiKey: "AIzaSyA6X5wCS0PC6jCYBQOO6gkaBk-5yQTHxOE",
        authDomain: "myfrac-fe018.firebaseapp.com",
        databaseURL: "https://myfrac-fe018.firebaseio.com",
        projectId: "myfrac-fe018",
        storageBucket: "myfrac-fe018.appspot.com",
        messagingSenderId: "809658471162",
        appId: "1:809658471162:web:f94f30c0716f22490faf43"
    }
}